import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/recover.pass.css';

export default function Recover() {
	const navigate = useNavigate?.() || null;
	const [message, setMessage] = useState(null);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [timeLeft, setTimeLeft] = useState(0);
	const [timerId, setTimerId] = useState(null);
	const [emailSentTo, setEmailSentTo] = useState('');

	const rawBase = (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '');
	const API_BASE = rawBase.replace(/\/$/, '');

	useEffect(() => {
		return () => {
			if (timerId) clearInterval(timerId);
		};
	}, [timerId]);

	function showMessage(text, type = 'success') {
		setMessage({ text, type });
		setTimeout(() => setMessage(null), 4000);
	}

	function startTimer(seconds = 60) {
		setTimeLeft(seconds);
		if (timerId) clearInterval(timerId);
		const id = setInterval(() => {
			setTimeLeft(t => {
				if (t <= 1) {
					clearInterval(id);
					return 0;
				}
				return t - 1;
			});
		}, 1000);
		setTimerId(id);
	}

	async function sendRecoverRequest(email) {
		// Separa la llamada para que el handler pueda decidir qué mostrar al usuario.
		try {
			const url = (API_BASE || '') + '/api/recover';
			console.debug('POST', url, { email });
			const res = await fetch(url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email })
			});
			const data = await res.json().catch(() => ({}));
			console.debug('recover response', res.status, data);
			return { ok: res.ok, status: res.status, data };
		} catch (err) {
			console.error('Error al llamar /recover', err);
			return { ok: false, status: 0, data: null, error: err };
		}
	}

	async function handleRecovery(e) {
		e.preventDefault();
		const form = e.target;
		const email = form.email?.value?.trim();
		if (!email) {
			showMessage('Por favor ingresa un correo válido', 'error');
			return;
		}

		setLoading(true);
		const result = await sendRecoverRequest(email);
		setLoading(false);

		// Para evitar enumeración de usuarios, siempre mostramos la UI de éxito
		setSuccess(true);
		setEmailSentTo(email);
		startTimer(60);

		// Mostrar mensaje genérico (el backend ya envía uno pero mantenemos la misma UX)
		if (result && result.data && result.data.message) {
			showMessage(result.data.message, 'success');
		} else {
			showMessage('Si existe una cuenta asociada, hemos enviado instrucciones para recuperar la contraseña.', 'success');
		}
	}

	async function handleResend() {
		if (timeLeft > 0) return;
		if (!emailSentTo) {
			showMessage('No hay correo para reenviar. Por favor solicita nuevamente.', 'error');
			return;
		}
		setLoading(true);
		const result = await sendRecoverRequest(emailSentTo);
		setLoading(false);
		// Mostrar UI de success siempre y reiniciar temporizador para evitar spam
		setSuccess(true);
		startTimer(60);
		showMessage('Si existe una cuenta asociada, hemos reenviado las instrucciones.', 'success');
	}

	function handleBackToLogin() {
		if (timerId) clearInterval(timerId);
		showMessage('Redirigiendo al inicio de sesión...', 'success');
		setTimeout(() => {
			if (navigate) navigate('/login');
			else window.location.href = '/login';
		}, 600);
	}

	return (
		<div className="recovery-wrapper">
			<div className="recovery-container">
				<div className="logo-container">
					<a href="/" aria-label="Ir a inicio">
						<img src="/logo512.png" alt="Ker Logo" className="logo-icon" />
					</a>
				</div>

				{message && <div className={`message ${message.type}`} style={{ display: 'block' }}>{message.text}</div>}

				<div className={`form-container ${success ? 'hidden' : ''}`}>
					<div className="icon-container"><div className="recovery-icon">🔐</div></div>
					<div className="recovery-header">
						<h1 className="recovery-title">Recuperar Contraseña</h1>
						<p className="recovery-subtitle">Te enviaremos un enlace para restablecer tu contraseña</p>
					</div>

					<form id="recovery-form" onSubmit={handleRecovery}>
						<div className="form-group">
							<label htmlFor="email">Correo electrónico</label>
							<div className="input-wrapper">
								<span className="input-icon">📧</span>
								<input type="email" id="email" name="email" placeholder="correo@ejemplo.com" required autoComplete="email" />
							</div>
						</div>

						<button type="submit" className="submit-button" id="submit-btn" disabled={loading}>
							<span className="button-content">
								<span id="button-text">{loading ? 'Enviando...' : 'Enviar enlace de recuperación'}</span>
								{loading && <div className="loading-spinner" style={{ display: 'block' }} />}
							</span>
						</button>

						<button type="button" className="back-button" onClick={handleBackToLogin}>← Volver al inicio de sesión</button>
					</form>
				</div>

				<div className={`success-container ${success ? 'active' : ''}`}>
					<div className="success-icon">✅</div>
					<h2 className="success-title">¡Correo enviado!</h2>
					<p className="success-message">Hemos enviado un enlace de recuperación a tu correo electrónico. Por favor revisa tu bandeja de entrada y sigue las instrucciones.</p>
					{emailSentTo && <p className="success-info">Enviado a: {emailSentTo}</p>}

					<div className="info-box">
						<div className="info-box-title">💡 <span>Información importante</span></div>
						<div className="info-box-content">
							• El enlace expirará en 1 hora<br />
							• Revisa tu carpeta de spam si no lo encuentras<br />
							• El enlace solo puede usarse una vez
						</div>
					</div>

					<div className="resend-section">
						<p className="resend-text">¿No recibiste el correo?</p>
						<button type="button" className="resend-button" onClick={handleResend} disabled={timeLeft > 0 || loading}>
							{timeLeft > 0 ? <>Reenviar en <span className="timer">{timeLeft}</span>s</> : 'Reenviar correo'}
						</button>
					</div>

					<button type="button" className="back-button" onClick={handleBackToLogin}>← Volver al inicio de sesión</button>
				</div>
			</div>
		</div>
	);
}

